import React from "react";
import FormGroupWrapper from "./FormGroupWrapper";
import { labelUtils, positionUtils } from "../Util";

import rootReducer from "../../../../store";
import { setRendererFormState } from "../../../../slices/common/reducer";
const Radio = ({
  arrEle,
  newElfromJSON,
  fieldEle,
  formState,
  displayLabelKey,
  databaseKey,
  showRequired = true,
}) => {
  let radioOptArray = fieldEle?.["data-customvalue"].split("#");
  let radioOptions = [];
  radioOptArray.forEach((opt) =>
    radioOptions.push({ key: opt, value: opt, label: opt })
  );

  let key = databaseKey ? databaseKey : displayLabelKey;

  return (
    <FormGroupWrapper
      arrEle={arrEle}
      newElfromJSON={newElfromJSON}
      fieldEle={fieldEle}
    >
      <div
        className="form-builder-element d-grid"
        id={newElfromJSON}
        data-colsize={fieldEle?.["display-noofcolumns"]}
        style={{
          display: "grid",
          gridTemplateColumns: positionUtils.getGridColumsforBoxes(fieldEle),
          visibility: fieldEle?.["display-hidden"] === 1 ? "hidden" : "",
          width: labelUtils.getElementWidth(fieldEle),
        }}
      >
        {radioOptArray.map((itm, i) => {
          return (
            <div
              key={itm}
              className={"form-group pl-4"}
              id={arrEle.elementid + "-col-" + (i + 1)}
              data-colpos={i + 1}
              style={{ marginTop: "8px" }}
            >
              <div className="pd-5">
                <label
                  htmlFor={key}
                  className={`form-check-label ${fieldEle?.["display-labelposition"]}`}
                >
                  <input
                    id={`${newElfromJSON}-${itm}`}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault();
                      }
                    }}
                    value={itm}
                    disabled={fieldEle?.["display-disabled"] === 1}
                    className="form-check-input"
                    type="radio"
                    name={key}
                    checked={formState[key] === itm}
                    onChange={(e) =>
                      rootReducer.dispatch(
                        setRendererFormState({ key, value: e.target.value })
                      )
                    }
                  />
                  <span className="label-text">{itm}</span>
                </label>
              </div>
            </div>
          );
        })}
        <div className="invalid-feedback">This field is required</div>
        {fieldEle?.["display-description"] && (
          <div className="form-text text-muted formElementDesc">
            {fieldEle?.["display-description"]}
          </div>
        )}
      </div>
    </FormGroupWrapper>
  );
};

export default Radio;
